/**
 * Remove dashes added by the formatter. We want to store phones as plain numbers
 */
const phoneParser = number => (number ? number.replace(/-/g, '') : '');


/* will add more parsers down the line, prefer not to change import & export syntax */
/* eslint-disable-next-line import/prefer-default-export */
export { phoneParser };
